import { render } from "./TemplateCotizacion.vue?vue&type=template&id=13d03ee5"
import script from "./TemplateCotizacion.vue?vue&type=script&lang=js"
export * from "./TemplateCotizacion.vue?vue&type=script&lang=js"

import "./TemplateCotizacion.vue?vue&type=style&index=0&id=13d03ee5&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__